export const TOP_LEVEL_NAV_ROUTES = {
    LOGIN: '/',
    HOME: '/home',
    REGISTER: '/register',
    CAMPAIGNS: '/campaigns',
    CREATE_CAMPAIGN: '/campaigns/create',
    CAMPAIGN_SETUP: '/campaigns/setup',
    CAMPAIGN_OVERVIEW: '/campaigns/:id',
    CAMPAIGN_OVERVIEW_LEGACY: '/campaigns/:id/legacy',
    CAMPAIGN_OVERVIEW_TAB: '/campaigns/:id/:tab',
    CUSTOMISE_FEATURE: '/campaigns/:campaignId/customise/:featureId',
    CUSTOMISE_FEATURE_STREAM: '/campaigns/:campaignId/manage-stream/:streamId/customise/:featureId',
    CUSTOMISE_CAMPAIGN: '/campaigns/:campaignId/customise',
    VISUAL_EDITOR_TEST: '/campaigns/:campaignId/visual-editor-test',
    MANAGE_CAMPAIGN_STREAM: '/campaigns/:campaignId/manage-stream/:streamId',
    USERS: '/users',
    ANALYTICS: '/analytics',
    SCHEDULE: '/schedule',
    SETTINGS: '/settings',
    BUG_REPORTS: '/bug-reports',
    NOT_AUTHORSIED: '/not-authorised',
    EDIT_DISPLAY_NAME: '/edit-display-name',
    QUIZZES: '/quizzes',
    CREATE_QUIZ: '/quizzes/create',
    EDIT_QUIZ: '/quizzes/:id',
    EDIT_CAMPAIGN_FEATURE_QUIZ: '/campaigns/:campaignId/customise/:featureId/quizzes/:id',
    EDIT_CAMPAIGN_STREAM_FEATURE_QUIZ: '/campaigns/:campaignId/manage-stream/:streamId/customise/:featureId/quizzes/:id',
    FEATURE: '/obs-feature/:campaignId/:streamId/:gamePIN',
    FEATURE_EXPIRED: '/obs-feature/expired',
    KOKO_DEBUG_TOOLS: '/koko-debug',
    CLAW_DEBUG_TOOLS: '/claw-debug',
    FEATURE_EDITOR: '/feature-editor',
    CLAW_CAMERA_FEED: '/claw-camera-feed',
    STREAMFOG_TEST: '/streamfog',
    TIMELINE_EDITOR: '/timeline-editor/:campaignId',
    SITE_ADMIN: '/site-admin',
    SITE_ADMIN_TAB: '/site-admin/:tab',
    SITE_ADMIN_EDIT_TEMPLATE: '/site-admin/templates/:templateId',
    INSPIRATION: '/inspiration',
}

export const NAV_AREAS = {
    HOME: 'home',
    CAMPAIGNS: 'campaigns',
    USERS: 'users',
    ANALYTICS: 'analytics',
    SCHEDULE: 'schedule',
    BUG_REPORTS: 'bug-reports',
    QUIZZES: 'quizzes',
    DEBUG: 'debug',
    SITE_ADMIN: 'site-admin',
    INSPIRATION: 'inspiration',
}
